import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterDataSetComponent } from './filter-data-set.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FormDataSetModule } from '../form-data-set';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    FilterDataSetComponent
  ],
  exports: [
    FilterDataSetComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    CardComponent,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    FormDataSetModule,
    MatDividerModule
  ]
})
export class FilterDataSetModule { }
